<template>
    <div class="wx-container" v-show="visiable">
        <i class="iconfont icon-cancel" @click="close"></i>
        <div id="wx_container" class="wx-code"></div>
    </div>
</template>

<script>
import { generateRandom } from "@/lib/utils";
import md5 from 'js-md5'
export default {
    props: {
        visiable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            state: ''
        }
    },
    watch: {
        visiable: {
            immediate: true,
            handler: function(val) {
                if (val) {
                    this.createQRCode()
                }
            }
        }
    },
    mounted() {
        var me = this;
        top.addEventListener('message', function(e) {
            if (e.origin !== 'https://ebbly.ifreegroup.net') {
                return
            }
            if (e.data) {
                me.validate(e.data)
            }
        }, false)
    },
    methods: {
        createQRCode() {
            let random = generateRandom();
            let secretCode = md5(`${random}`);
            this.state = secretCode;
            let wx = new WxLogin({
                self_redirect: true,
                id: "wx_container",
                appid: "wxc5a0aabaf81acfba", 
                scope: "snsapi_login", 
                redirect_uri: encodeURIComponent('https://ebbly.ifreegroup.net/#/wechat'),
                state: secretCode
            })
        },
        validate({code, state}) {
            if (this.state === state && code) {
                //获取用户信息
                this.$req.post('wxlogin', {
                    code: code
                }).then(({data}) => {
                    if (data.code === '2000') {
                        this.openLogin(data.data)
                    } else {
                        this.$message(data.msg, 'error');
                        this.close();
                    }
                })
            } else {
                console.info('auth error');
            }
        },
        openLogin(info) {
            this.$req.post('webopenlogin', {
                avatar: info.headimgurl,
                nikename: info.nickname,
                openid: info.unionid,
                type_id: 2
            }).then(({data}) => {
                if (data.code === '2000') {
                    data.data.user_info.nickname = val.nickname;
                    this.$store.dispatch('updateToken', data.data.token);
                    this.$store.dispatch('updateUser', data.data);
                    this.$store.dispatch('updateAvatar', info.headimgurl);
                    this.close();
                    this.$store.dispatch('toggleShowLogin', false);
                } else {
                    this.$message(data.msg, 'error');
                    this.close();
                }
            })
        },
        close() {
            this.$emit('update:visiable', false);
        }
    }
}
</script>

<style lang="scss" scoped>
.wx-container {
    position: relative;
    width: 700px;
    height: 500px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2);
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        &:hover {
            color: #009ABA;
        }
    }

    .wx-code {
        width: 300px;
        height: 400px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Public/components/WxPanel.vue